<template>
  <div class="login_Repassword">
    <div class="wrap">
      <!--header start-->
      <div class="header login-header">
        <a href="javascript:void(0);" @click="fn" class="icon-back"></a>找回密码
      </div>
      <div class="line-gray"></div>
      <!--header end-->

      <!--content start-->
      <div class="content login-content">
        <form class="lg-tabbox">
          <div class="group-item">
            <label>账号</label>
            <div class="input-box input-tel">
              <input type="tel" placeholder="请输入手机号" id="MobilePhone" class="" maxlength="11" v-model="MobilePhone"/>
              <div class="btn-del" style="display: none" v-show="MobilePhone != ''" @click="MobilePhone = ''">
              </div>
            </div>
          </div>
          <p class="text-danger" style="display:none" id='MobilePhone-mess'></p>
          <div class="group-item">
            <label>新密码</label>
            <div class="input-box">
              <input type="password" id="pass" placeholder="6-20位任意字符区分大小写"/>
            </div>
          </div>
          <p class="text-danger" style="display:none" id="pass-mess"></p>
          <div class="group-item">
            <label>确认密码</label>
            <div class="input-box">
              <input type="password" id="repass" placeholder="再次输入密码"/>
            </div>
          </div>
          <p class="text-danger" style="display:none" id="repass-mess"></p>
          <div class="group-item">
            <label>图形验证</label>
            <div class="input-box input-picyz">
              <input type="text" placeholder="" id="img_yzm" placeholder="请输入验证码"/>
              <img class="picyz" src="http://reg.cctv.com/simple/verificationCode.action"/>
            </div>
          </div>
          <p class="text-danger" style="display:none" id="img-yzm-mess"></p>
          <div class="group-item">
            <label>验证码</label>
            <div class="input-box input-yzm">
              <input type="text" placeholder="请输入验证码" id="yzm"/>
              <a href="javascript:void(0);" class="btn-yzm puts">发送验证码</a>
            </div>
          </div>
          <p class="text-danger" style="display:none" id="yzm-mess"></p>
          <div class="group-terms">
            <div :class="checked?'check-box oncheck':'check-box'" @click="checked = !checked">
              <input type="checkbox">
            </div>
            <p class="terms">
              阅读并同意<a href="javascript:void(0);">《央视网网络服务使用协议》</a>
            </p>
          </div>
          <p class="text-danger" id="xieyi-mess"></p>
          <div class="group-info">
            <a href="javascript:void(0);" id="reback" class="font-lgr">完&nbsp;&nbsp;成</a>
          </div>
        </form>
      </div>
      <!--content end-->

    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        MobilePhone: '',
        checked: false,
      }
    },
    methods: {
      //操作按钮事件
      fn() {
        if (window.history.length <= 1) {
          this.$router.push({name: 'home'});
        } else {
          this.$router.back(-1)
        }
      }
    },
    mounted: function () {
      var that = this
      //操作DOM
      $('.modal-backdrop').remove()
      // checkbok 选中函数
      $('.check-box').on('click', function () {
        if ($(this).hasClass('oncheck')) {
          $(this).removeClass('oncheck');
        } else {
          $(this).addClass('oncheck');
        }
      });


      $('.picyz').click(function () {
        $(this).attr('src', 'http://reg.cctv.com/simple/verificationCode.action?v=' + Math.random());
      })
      //发送验证码
      $('.puts').click(function () {
        $('#img-yzm-mess').hide();
        $('#MobilePhone-mess').hide();
        var acc = $('#MobilePhone').val();//账号
        var yzm_img = $('#img_yzm').val();//图形验证码
        var num = 180;
        if (!acc) {
          $('#MobilePhone-mess').show();
          $('#MobilePhone-mess').html('请输入手机号');
          return;
        }
        if (acc.match(/^1[3|5|7|8|9|][0-9]{9}$/) !== null || acc.match(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/) !== null) {
        } else {
          $('#MobilePhone-mess').show();
          $('#MobilePhone-mess').html('手机号格式不正确');
          return;
        }
        if (!yzm_img) {
          $('#img-yzm-mess').show();
          $('#img-yzm-mess').html('请输入图形验证码');
          return;
        }
        $.ajax({
          url: 'http://reg.cctv.com/regist/getVerifiCode.action',
          data: {
            method: 'getRequestVerifiCodeM',
            mobile: acc,
            verfiCodeType: 1,
            verificationCode: yzm_img,
            isCheckCode: 0
          },
          dataType: 'jsonp',
          success: function (mes) {
            if (mes.errtype == 'success') {
              $('.puts').unbind('click');
              var set = setInterval(function () {
                num = num - 1;
                $('.btn-yzm').html(num + '秒后获取');
                if (num == 0) {
                  $('.btn-yzm').html('发送验证码');
                  getcode();
                  clearInterval(set);
                }

              }, 1000)
            }
            if (mes.errtype == 'mobilecodeerror') {
              $('#yzm-img').show();
              $('#yzm-img').html(mes.errmsg);
              $(this).attr('src', 'http://reg.cctv.com/simple/verificationCode.action?v=' + Math.random());
            }
            if (mes.errtype == 'ipsendagain') {
              $('#yzm-img').show();
              $('#yzm-img').html('验证过于频繁,请稍后重试');
            }
            if (mes.errtype == 'mobileoften') {
              $('#yzm-img').show();
              $('#yzm-img').html('验证过于频繁,请稍后重试');
            }
            if (mes.errtype == 'registered') {
              $('#phone-mess').show();
              $('#phone-mess').html(mes.errmsg);
            }
            if (mes.errtype == 'sendagain') {
              $('#yzm-mess').show();
              $('#yzm-mess').html('验证过于频繁,请稍后重试');
            }
          }
        })
      })
      //完成按钮事件函数
      $('#reback').click(function () {

        $('#MobilePhone-mess').hide();
        $('#yzm-mess').hide();
        $('#pass-mess').hide();
        $('#repass-mess').hide();
        $('#img-yzm-mess').hide();
        $('#xieyi-mess').hide();

        var url=encodeURI('http://ishow.xiyou.cctv.com/');
        var phone = that.MobilePhone;
        var acc = $('#MobilePhone').val();//账号
        var yzm_data = $('#yzm').val();//手机验证码
        var pass = $('#pass').val();//密码
        var repass = $('#repass').val();//确认密码
        var yzm_img = $('#img_yzm').val();//图形验证码
        var yzm = $('#yzm').val(); //手机验证码
        var num = 180;


        if (!acc) {

          $('#MobilePhone-mess').show();
          $('#MobilePhone-mess').html('手机号格式不正确');
          return;
        }
        if (acc.match(/^1[3|5|7|8|9|][0-9]{9}$/) !== null || acc.match(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/) !== null) {
        } else {
          $('#MobilePhone-mess').show();
          $('#MobilePhone-mess').html('请输入手机号');
          return;
        }
        if (pass.length < 6 || pass.length > 20) {
          $('#pass-mess').show();
          $('#pass-mess').html('请输入6-20位的密码');
          return;
        } else {
          $('#pass-mess-email').hide();
        }
        if (pass != repass) {
          $('#repass-mess').show();
          $('#repass-mess').html('两次输入密码不一致');
          return;
        } else {
          $('#repass-mess').hide();
        }

        if (!yzm_img) {
          $('#img-yzm-mess').show();
          $('#img-yzm-mess').html('请输入图形验证码');
          return;
        }


        if ($('.group-terms').find('.oncheck').length == 0) {
          $('#xieyi-mess').show();
          $('#xieyi-mess').html('请同意使用协议');
          return;
        }
        if($('#yzm').val() == ''){
          $('.text-danger').show();
          return;
        }
        $.ajax({
          url: 'https://reg.cctv.com/regist/resetPasswdByMobile.action',
          data: {
            mobile: that.MobilePhone,
            verfiCode: yzm,
            passWd: pass,
            from: url
          },
          dataType: 'jsonp',
          jsonp:'callback',
          success: function (mes) {
            console.log(mes)
            if (mes.errtype == '0' || mes.msg == '成功') {
              that.$router.back(-1)
            }
            if (mes.errtype == 'registered') {
              $('#yzm-mess').show();
              $('#yzm-mess').html(mes.errmsg);
            }
            if (mes.errtype == 'error') {
              $('#yzm-mess').show();
              $('#yzm-mess').html(mes.errmsg);
            }
            if (mes.errtype == 'timeout') {
              $('#yzm-mess').show();
              $('#yzm-mess').html(mes.errmsg);
            }
          }
        })

      })

    }

  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/login/repassword.vue